import axios from 'axios'

// Adding these needs the product modal: reservables, variations (resource pools) and custom-priced value cards
export function productNeedsModal (product) {
  return parseInt(product.type, 10) === 1 || !!(product.sharedResourcepool && product.sharedResourcepool.length) || !!(product.minprice || product.maxprice)
}

export default {
  methods: {
    getProductComponent (product) {
      if (!product.product) {
        return resolveComponent('InvalidProductListItem')
      }
      switch (product.type) {
        case '0':
          if (product.product.sharedResourcepool && product.product.sharedResourcepool.length) { // Product variations require a popup
            return resolveComponent('ReservableProductListItem')
          }
          if (product.product.minprice || product.product.maxprice) { // Custom-priced value cards also require a popup
            return resolveComponent('ReservableProductListItem')
          }
          if (parseInt(product.subtype,10) === 8) {
            return resolveComponent('ContentProductListItem')
          }
          return resolveComponent('BuyableProductListItem')
        default:
          return resolveComponent('ReservableProductListItem')
      }
    },
    loadProducts (callback = function() {}) {
      let $this = this
      if (this.data && this.data.categoryId) {
        this.categoryId = this.data.categoryId
        axios.get(this.baseDomain + this.shopId + '/categories/' + this.data.categoryId + '/allproducts.json?fulldetails=true&all=true&version=' + this.version)
        .then(function (response) {
          $this.products = response.data
          callback(true)
        })
        .catch(function (e) {
          console.log('Failed to load products.')
          callback(false)
        })
      }
    },
    loadLinkedCategories (callback = function() {}) {
      let $this = this
      if (this.data && this.data.categoryIds) {
        this.categoryIds = this.data.categoryIds
        let promiseArray = this.categoryIds.map(cat => axios.get(this.baseDomain + cat.shopId + '/categories/' + cat.id + '/allproducts.json?fulldetails=true&all=true&version=' + this.version))
        axios.all(promiseArray)
        .then(function (results) {
          //$this.subProducts[parseInt(response.data.id,10)] = response.data
          let resultProducts = []
          for(let i = 0; i < results.length; i++) {
            resultProducts.push.apply(resultProducts, results[i].data)
          }
          $this.products = resultProducts
          callback(true)
        })
        .catch(function (e) {
          console.log('Failed to load products.')
          callback(false)
        })
      }
    },
    loadProduct (shopId, id) {
      let $this = this
      axios.get(this.baseDomain + shopId + '/products/' + id + '.json?version=' + this.version + '&pricewithoptions=true')
      .then(function (response) {
        let product = response.data
        for (var i = 0; i < $this.products.length; i++) {
          if ($this.products[i].shopid == shopId && $this.products[i].source_id == id) {
            $this.products[i].product = product
          }
        }
      })
      .catch(function (e) {
        console.log('Failed to load products.', e)
      })
    }
  },
  watch: {
    version () {
      this.loadProducts()
    }
  }
}